var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpikCalls({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    height: "100px",
    id: "Layer_1",
    viewBox: "0 0 100 100",
    width: "100px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.185,5H13.815c-2.032,0-3.685,1.653-3.685,3.685v82.631c0,2.031,1.652,3.685,3.685,3.685h72.369   c2.032,0,3.685-1.653,3.685-3.685V8.685C89.869,6.653,88.217,5,86.185,5z M37.972,84.654c0.78,0,1.634-0.194,2.073-0.385   l0.855-0.373l0.684,3.854l-0.465,0.254c-0.602,0.327-1.857,0.678-3.576,0.678c-4.444,0-7.316-2.974-7.316-7.575   c0-4.786,3.053-8.002,7.596-8.002c1.628,0,2.853,0.364,3.456,0.704l0.48,0.271l-0.909,3.866l-0.816-0.372   c-0.641-0.293-1.34-0.441-2.08-0.441c-2.08,0-3.272,1.381-3.272,3.79C34.681,83.295,35.88,84.654,37.972,84.654z M48.867,88.683   c-1.55,0-3.506-0.546-4.293-1.035l-0.42-0.261l0.629-3.825l0.927,0.534c0.618,0.356,2.058,0.753,3.136,0.753   c0.743,0,1.187-0.345,1.187-0.923c0-0.256,0-0.605-1.572-1.239c-2.52-0.987-3.798-2.576-3.798-4.723   c0-2.86,2.194-4.858,5.336-4.858c1.44,0,3.049,0.434,3.895,0.861l0.54,0.274l-1.021,3.701l-0.819-0.444   c-0.399-0.216-1.421-0.559-2.464-0.559c-0.865,0-0.934,0.582-0.934,0.761c0,0.298,0,0.514,1.712,1.245   c2.458,1.022,3.603,2.534,3.603,4.758C54.509,86,53.031,88.683,48.867,88.683z M65.24,88.683h-4.599l-4.313-15.342h4.846   l1.62,6.434c0.13,0.512,0.267,1.054,0.402,1.619c0.125-0.516,0.258-1.04,0.397-1.565l1.695-6.487h4.484L65.24,88.683z    M15.264,67.654l0.002-57.521h69.466l0.012,57.521H15.264z",
    fill: "#589C00"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#589C00",
    height: 8.706,
    width: 13.059,
    x: 61.172,
    y: 21.192
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#589C00",
    height: 8.706,
    width: 13.059,
    x: 61.172,
    y: 34.541
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#589C00",
    height: 8.705,
    width: 13.059,
    x: 61.172,
    y: 47.89
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#589C00",
    height: 8.705,
    width: 13.059,
    x: 43.471,
    y: 47.89
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#589C00",
    height: 8.705,
    width: 13.059,
    x: 25.77,
    y: 47.89
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#589C00",
    points: "47.275,31.912 55.117,22.104 47.331,22.104 43.33,27.386 39.531,22.104 31.467,22.104     39.455,32.138 31.138,42.771 38.897,42.771 43.322,36.793 47.706,42.771 55.804,42.771   "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpikCalls);
export default __webpack_public_path__ + "static/media/epik-calls.184f6a8db54eb495e3b966f25347f83d.svg";
export { ForwardRef as ReactComponent };